/* REACT PACKAGE IMPORTS */
import { useEffect, useState, useRef, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Routes, Route, Navigate } from "react-router-dom";

/* INTERNAL IMPORTS */
// Pages
import Candidate from "./Pages/Candidate";
import CandidateLogin from "./Pages/CandidateLogin";
import NoMatch from "./Pages/NoMatch";
import FallbackComponent from "./Pages/FallbackComponent";
import Unauthorized from "./Pages/Unauthorized";

// Components
import Layout from "./Components/Layout";
import ErrorBoundary from "./Components/ErrorBoundary";
import SimpleSnackbar from "./Components/SnackBar";
import RequireAuth from "./Components/RequireAuth";

// Styling
import "./styles/App.css";
import "./styles/Button.css";
import "./styles/theme.css";
import "./styles/Form.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { ThemeContext } from "./Theme/ThemeContext";

// Images
import logoFIFA from "./assets/FIFA_logo.png";


/**
 * Most applications will need to conditionally render certain components based on whether a user is signed in or not.
 * msal-react provides 2 easy ways to do this. AuthenticatedTemplate and UnauthenticatedTemplate components will
 * only render their children if a user is authenticated or unauthenticated, respectively. For more, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-react/docs/getting-started.md
 */
const App = ({ authToken }) => {
  const context = useContext(ThemeContext);
  const [logoID, setLogoId] = useState(logoFIFA);
  const { userInfo } = useSelector((store) => store.auth);
  const mounted = useRef(null);

  useEffect(() => {
    mounted.current = true;
    if (mounted.current) {
      if (userInfo) {
        const { theme } = userInfo;
        var body = document.querySelector("body");
        if (theme.length === 0) {
          body.style.setProperty("--bkg-color", "#fafafa");
          body.style.setProperty("--bkgsecondary", "#ffffff");
          body.style.setProperty("--text-color", "#020208");
          context.toggleColorMode("light");
          setLogoId(logoFIFA);
          return;
        } else {
          const themeObj = JSON.parse(theme);
          const primarycolor = themeObj.primarycolor;
          const secondarycolor = themeObj.secondarycolor;
          const fontcolor = themeObj.fontcolor;
          const logo = themeObj.logo;
          const mode = themeObj.mode;
          body.style.setProperty("--bkg-color", primarycolor);
          body.style.setProperty("--bkgsecondary", secondarycolor);
          body.style.setProperty("--text-color", fontcolor);
          if (mode !== null) context.toggleColorMode(mode);
          else context.toggleColorMode("light");
          if (logo !== null) setLogoId(logo);
          else setLogoId(logoFIFA);
          return;
        }
      }
    }
  }, [userInfo, logoID, context]);

  return (
    <div>
      <ErrorBoundary>
        {/* show errors */}
        <SimpleSnackbar />

        <Routes>
          {/* public routes */}
          <Route
            path="login"
            element={<CandidateLogin logo={logoID} authToken={authToken} />}
          />
          <Route
            path="login?"
            element={<CandidateLogin logo={logoID} authToken={authToken} />}
          />
            {/* candidate routes */}
            <Route
              path="/"
              element={
                <RequireAuth />
              }
            >
              <Route path="/" element={<Navigate to="/candidate/assessments" />} />
              <Route
                path="/candidate"
                element={<Navigate to="/candidate/assessments" />}
              />
              <Route
                path="candidate"
                element={
                  <Layout isEmbedded={true} logo={logoID} tabs={["Home"]} />
                }
              >
                <Route path="*" element={<Candidate />} />
                <Route path="/candidate/error" element={<NoMatch />} />
              </Route>
            </Route>

          {/* catch all */}
          <Route path="unauthorized" element={<Unauthorized />} />
          {/* catch all */}
          <Route path="*" element={<NoMatch />} />
        </Routes>
      </ErrorBoundary>
    </div>
  );
};

export default App;
